import { Component } from "react";
import { withRouter } from "react-router-dom";

/* A browser resets the scroll position when it loads a page; a router does
 * not. Without this, following a link from halfway down one page lands you
 * halfway down the next one, which reads as the page having failed to change.
 *
 * Jumps rather than smooth-scrolls: this is the start of a new page, not a
 * movement within the current one, and it must not animate past content the
 * reader never asked to see. A hash link (the Resources jump row) is left
 * alone, since the browser is already taking it somewhere specific.
 */
class ScrollToTop extends Component {
  componentDidUpdate(prev) {
    const { location } = this.props;
    if (location.pathname === prev.location.pathname) return;
    if (location.hash) return;

    window.scrollTo(0, 0);
  }

  render() {
    return null;
  }
}

export default withRouter(ScrollToTop);
